/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import { routesPath } from '../../common/constants/routesPath';
import { useTranslation } from 'react-i18next';
import classes from './style.module.scss';

const FeedbackTemplatePage = ({ status, title, subTitle, showIcon = false }) => {
    const navigate = useNavigate();
    const { t } = useTranslation(['notFoundPage']);

    function onClickBackHome() {
        navigate(routesPath.ROOT.DASHBOARD);
    }

    return (
        <Result
            status={status}
            title={title}
            subTitle={subTitle}
            icon={showIcon}
            extra={
                <Button onClick={onClickBackHome} className={classes.button} type="primary">
                    {t('button')}
                </Button>
            }
        />
    );
};

export default FeedbackTemplatePage;
